import { useMutation } from '@tanstack/react-query';
import { updateUserInsightsShowHiddenItems } from 'shared/services/backend-api';

export const useUpdateInsightsShowHiddenItemsMutation = () =>
  useMutation({
    mutationFn: async (showHiddenItems: boolean) =>
      updateUserInsightsShowHiddenItems(showHiddenItems),
  });
